import { render, staticRenderFns } from "./EventStatusCancelledWarning_en.vue?vue&type=template&id=61a8a124&"
import script from "./EventStatusCancelledWarning_en.vue?vue&type=script&lang=js&"
export * from "./EventStatusCancelledWarning_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports